import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3e4095', // texto escuro
      contrastText: '#fff', // contraste para botões primários
    },
    secondary: {
      main: '#ed3237', // laranja vibrante
      contrastText: '#fff',
    },
    background: {
      default: '#F4F6F8', // fundo geral da página
      paper: '#ffffff',   // fundo de caixas
    },
    text: {
      primary: '#3e4095',
      secondary: '#666',
    },
  },
  typography: {
    fontFamily: ['"Roboto"', 'sans-serif'].join(','),
    h6: {
      fontWeight: 600,
      fontSize: '1.1rem',
      color: '#3e4095',
    },
    button: {
      fontWeight: 700,
      textTransform: 'uppercase',
    },
  },
  components: {
    MuiTextField: {
  styleOverrides: {
    root: {
      '& .MuiInputBase-root': {
        backgroundColor: '#fcf2f2ff', // campo sempre com fundo branco
        borderRadius: 4,
      },
      '& .MuiInputBase-input': {
        color: '#3e4095', // texto escuro
      },
      '& label': {
        color: '#888',
      },
      '& label.Mui-focused': {
        color: '#ed3237', // cor do label quando em foco
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ccc',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#999',
      },
      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ed3237', // cor da borda ao focar
      },
    },
  },
},

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: '2rem',
          paddingBottom: '2rem',
        },
      },
    },
  },
});

export default theme;
